
<template>
  <!-- eslint-disable vue/require-component-is -->
  <component v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    to: {
      type: [String, Object],
      required: true
    }
  },
  methods: {
    linkProps (url) {
      if (typeof url.fullPath === 'string') {
        return {
          is: 'a',
          href: url.fullPath,
          target: url.target,
          rel: 'noopener'
        };
      }
      return {
        is: 'router-link',
        to: url
      };
    }
  }
};
</script>
